export default __webpack_public_path__ + "static/media/slider-05-remove@2x.77a47e07.png";